import React from "react";

function DashboardTitles({ username }) {
  return (
    <>
      <h1 className="text-primary-900 dark:text-primary-200 md:text-2xl text-xl font-semibold mb-1">
        Dashboard
      </h1>
      <h5 className="md:mb-20px mb-16px text-accent-400 text-sm">
        Welcome back <span className="uppercase">{username}</span> !
      </h5>
    </>
  );
}

export default DashboardTitles;
